import React from 'react';
import Image from 'next/image';
import { Tab } from '@headlessui/react';
import { useRouter } from 'next/router';
import { useUser } from '../../../hooks';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import logo from '../../../public/img/logos/logo-carreras-light.png';
import { Button } from '../../commons';
import SupportForm from './SupportForm';

export default function FirstStep() {
  const router = useRouter();
  const [user] = useUser();

  React.useEffect(
    function syncAuth() {
      if (user) {
        router.push('/request-scholarship/[...id]', `/request-scholarship/2`);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  );
  return (
    <div className="p-4 lg:py-20 lg:px-32 flex flex-col">
      <Image src={logo} alt="Carreras logo" className="w-[280px]" />
      <div className="mt-8">
        <p className="font-semibold text-lg text-neutral-500 mt-2">
          Welcome to the Carreras Limited Scholarship Application Portal
        </p>
      </div>
      <div className="mt-8 w-full">
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-[5px] bg-neutral-300">
            <Tab
              key="message"
              className={({
                selected,
              }) => `w-full rounded-l-[5px] py-2 px-2.5 text-[20px] h-11 font-medium leading-5 text-white
                   ${selected ? 'bg-green' : ''}`}
            >
              Message
            </Tab>
            <Tab
              key="signin"
              className={({
                selected,
              }) => `w-full rounded-l-[5px] py-2 px-2.5 text-[20px] h-11 font-medium leading-5 text-white
                   ${selected ? 'bg-green' : ''}`}
            >
              Sign In
            </Tab>
            <Tab
              key="signup"
              className={({
                selected,
              }) => `w-full rounded-r-[5px] py-2 px-2.5 text-[20px] h-11 font-medium leading-5 text-white
                   ${selected ? 'bg-green' : ''}`}
            >
              New Account
            </Tab>
            <Tab
              key="support"
              className={({
                selected,
              }) => `w-full rounded-r-[5px] py-2 px-2.5 text-[20px] h-11 font-medium leading-5 text-white
                   ${selected ? 'bg-green' : ''}`}
            >
              Support
            </Tab>
          </Tab.List>
          <Tab.Panels className="mt-2">
            <Tab.Panel key="message" className="">
              <div className="flex flex-col w-full space-y-4">
                <p className="">
                  <span className="font-bold">New Users:</span> Please click on
                  "Create New Account" to complete the registration process and
                  create your logon credentials.
                </p>
                <p className="">
                  <span className="font-bold">Existing Users:</span> Please
                  enter your credentials and sign in. If you forgot your
                  password, please use the "Forgot your Password" link to the
                  left to reset your password.
                </p>
              </div>
            </Tab.Panel>
            <Tab.Panel key="signin" className="">
              <SignInForm />
            </Tab.Panel>
            <Tab.Panel key="signup" className="">
              <SignUpForm />
            </Tab.Panel>
            <Tab.Panel key="support" className="">
              <div className="my-8">
                <p className="">
                  For any inquiries or issues arising from your online
                  application, kindly complete the contact form below and our
                  team will get back to you in 24 to 48 hours.
                </p>
                <SupportForm />
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}
